export default "__VITE_ASSET__CmHMJf_p__"